"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticateStatusSelector = authenticateStatusSelector;
exports.codeErrorSelector = codeErrorSelector;
exports.hasCodeErrorSelector = hasCodeErrorSelector;
exports.isAutosubmitEnabledSelector = isAutosubmitEnabledSelector;
exports.isPhoneInvalidSelector = isPhoneInvalidSelector;
exports.isSubmitDisabledSelector = isSubmitDisabledSelector;
exports.loginSelector = loginSelector;
exports.phoneErrorSelector = phoneErrorSelector;
exports.phoneSelector = phoneSelector;
exports.twoFactorStatusSelector = twoFactorStatusSelector;
var _authentication = require("../../../../types/authentication");
var _validation = require("../../../../utils/validation");
var _requestStatus = require("../../../../types/requestStatus");
function authenticateStatusSelector(state) {
  return state.authentication.authenticate.status;
}
function twoFactorStatusSelector(state) {
  return state.authentication.twoFactor.phoneState.status;
}
function hasCodeErrorSelector(state) {
  const {
    status,
    errorType
  } = state.authentication.authenticate;
  return status === _authentication.EAuthenticateStatus.Failed && errorType !== _authentication.EAuthenticateError.TwoFactorRequired;
}
function codeErrorSelector(state) {
  if (!hasCodeErrorSelector(state)) {
    return undefined;
  }
  return state.authentication.authenticate.error;
}
function loginSelector(state) {
  return state.login;
}
function phoneSelector(state) {
  return state.authentication.twoFactor.phoneState.phone;
}
function phoneErrorSelector(state) {
  return state.authentication.twoFactor.phoneState.error;
}
function isSubmitDisabledSelector(state) {
  const twoFactorStatus = twoFactorStatusSelector(state);
  const authenticateStatus = authenticateStatusSelector(state);
  return [_authentication.EAuthenticateStatus.Loading, _authentication.EAuthenticateStatus.Succeed].includes(authenticateStatus) || twoFactorStatus === _requestStatus.ERequestStatus.Loading;
}
function isPhoneInvalidSelector(state) {
  const phone = phoneSelector(state);
  return !(0, _validation.isValidPhone)(phone);
}
function isAutosubmitEnabledSelector(state) {
  return state.authentication.twoFactor.phoneState.isAutosubmitEnabled;
}